import React from 'react';

const PDFBottom = (props) => {
    return <></>;
};

export default PDFBottom;
